import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { CRITERIA } from '../constant'
import { getPortfolioOverview } from './thunk'

const initialState = {
  analyse: CRITERIA.PERFORMANCE_SCORE.value,
  versus: CRITERIA.CREDIT_RISK_SCORE.value,
  isHighlight: false,

  data: {},

  loading: {
    data: true,
  },
}

export const slice = createSlice({
  name: 'portfolio/summary/portfolioOverview',
  initialState,
  reducers: {
    resetStorePortfolioOverview: (state) => {
      return {
        ...initialState,
        analyse: state.analyse,
        versus: state.versus,
      }
    },
    changeAnalyse: (state, action) => {
      state.analyse = action.payload
    },
    changeVersus: (state, action) => {
      state.versus = action.payload
    },
    changeIsHighlight: (state, action) => {
      state.isHighlight = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPortfolioOverview.pending, (state) => {
      state.loading.data = true
    })
    builder.addCase(
      getPortfolioOverview.fulfilled,
      (state, { payload = {} }) => {
        state.data = payload
        state.loading.data = false
      },
    )
    builder.addCase(getPortfolioOverview.rejected, (state, action) => {
      state.data = {}
      state.loading.data = action.payload.loading
    })
  },
})

export const selectAnalyse = (state) => state[slice.name].analyse
export const selectVersus = (state) => state[slice.name].versus

export const selectData = (state) => state[slice.name].data

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return loadingObj[type]
}

export const selectIsHighlight = (state) => state[slice.name].isHighlight

export const {
  resetStorePortfolioOverview,
  changeAnalyse,
  changeVersus,
  changeIsHighlight,
} = slice.actions

register(slice.name, slice.reducer)
